/* global axios */
import ApiClient from './ApiClient';

class FinanceAPI extends ApiClient {
  constructor() {
    super('finance', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  subscribe(itemType, quantity, missingDeps = []) {
    return axios.post(`${this.url}/subscribe`, {
      item_type: itemType,
      quantity,
      missing_deps: missingDeps,
    });
  }

  savePreferences(billingPreference, billingEmail, billingPhone) {
    return axios.post(`${this.url}/preferences`, {
      billing_preference: billingPreference,
      billing_email: billingEmail,
      billing_phone: billingPhone,
    });
  }

  sendInvoice(invoiceId, url, type, target) {
    return axios.post(`${this.url}/send_invoice`, {
      invoice_id: invoiceId,
      url,
      type,
      target,
    });
  }

  changePlan(planId, subscriptionsToCancel = []) {
    return axios.post(`${this.url}/change_plan`, {
      plan_id: planId,
      subscriptions_to_cancel: subscriptionsToCancel,
    });
  }

  cancelSubscription(subscriptionId) {
    return axios.post(`${this.url}/cancel_subscription`, {
      subscription_id: subscriptionId,
    });
  }
}

export default new FinanceAPI();
